import { render, staticRenderFns } from "./SimplifiedGlobalHeader.vue?vue&type=template&id=ec9e0d4e&"
import script from "./SimplifiedGlobalHeader.vue?vue&type=script&lang=js&"
export * from "./SimplifiedGlobalHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedGlobalHeader.vue?vue&type=style&index=0&id=ec9e0d4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports